<template>
  <div>
    <el-button @click="depClick" size="mini" type="primary"
      >重新选择部门</el-button
    >
    <Department
      v-show="false"
      ref="deps"
      :options="{ branch: 3 }"
      :value.sync="deps"
      :person="false"
      multiple
      @change="changeDep"
    />
    <LyTable ref="tableMain" :list="list" />
  </div>
</template>

<script>
import { getAllotUser, setCheckDepartment } from "@/modules/allotModel";
import Department from "@/components/Department";
export default {
  name: "DepartmentAllot",
  props: {
    branch: { type: Object },
    type: { type: String },
  },
  components: {
    Department,
  },
  data() {
    return {
      list: [],
      deps: [],
    };
  },
  mounted() {
    this.init();
    this.getList();
  },
  computed: {
    tableConfig() {
      return {
        columns: [
          { label: "序号", prop: "id" },
          { label: "部门", prop: "value_desc" },
        ],
      };
    },
  },
  methods: {
    init() {
      this.$refs["tableMain"].init(this.tableConfig);
    },
    async getList() {
      const req = await await getAllotUser({
        branch: this.branch.id,
        pageSize: 9999,
        allocation_type: this.type,
      });
      const { code, msg, data } = await req.json();
      if (code !== 200) {
        this.$message.error(msg);
        return;
      }
      this.list = data.list;
      this.deps = this.list.map((item) => {
        return Number(item.value);
      });
    },
    async depClick() {
      let confirm = await this.$confirm(
        "重新选择部门后，新部门将覆盖现有部门并开始自动分配?",
        "重新导入名单确认",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      );
      if (confirm !== "confirm") return;
      this.$refs["deps"].openDialog();
      this.$refs["deps"].initCurrentDep();
    },
    async changeDep(value) {
      console.log(value)
      const req = await await setCheckDepartment({
        allocation_department: value,
        branch: this.branch.id,
        save: 1,
      });
      const { code, msg } = await req.json();
      if (code !== 200) {
        this.$message.error(msg);
        return;
      }
      this.$message.success("保存成功！");
      this.getList();
    },
  },
};
</script>

<style>
</style>